/** Minimal user shape needed to build a display label. */
interface UserDisplayFields {
  name?: string | null;
  email?: string | null;
}

/**
 * Returns the label used to refer to a user in the UI: their name, falling back to their email.
 * @returns undefined when the user has neither a name nor an email
 */
export function getUserDisplayName(user: UserDisplayFields): string | undefined {
  return user.name || user.email || undefined;
}

/**
 * Returns the uppercase first letter of the user's display name, for avatar placeholders.
 * @returns null when the user has neither a name nor an email
 */
export function getUserInitial(user: UserDisplayFields): string | null {
  const displayName = getUserDisplayName(user);
  return displayName ? displayName.charAt(0).toUpperCase() : null;
}

/**
 * Returns up to `max` uppercase initials of a full name (e.g. "John Doe" → "JD").
 */
export function getInitials(name: string, max = 2): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, max);
}
